enum ValidWeekday {
  Invalid,
  SameDay,
  PreviousDay
}

export default ValidWeekday
